<template>
	<div class="modified-plastics">
		<title-top id="arch1" ></title-top>
		<div class="mainword">
			<div class="inculdtitle">
				<span class="titleword0">{{$t("chaper1[0]")}}</span>
				<div @click="toggleshow" class="svg0">
					<open-book></open-book>
				</div>
			</div>
			<div class="addphone-wrapper">
				<div class="addphone">{{$t("addphone[0][0]")}}</div>
				<div class="addphone">{{$t("addphone[0][1]")}}</div>
				<div class="addphone">{{$t("addphone[0][2]")}}</div>
			</div>
			<div class="inculdtitle">
				<span class="titleword1">{{$t("chaper1[1]")}}</span>
			</div>
			<transition-group name="fade">
				<div :key="'mykey' + index" v-show="isshow0" class="inner" v-for="(item, index) in stepLists">
					<span class="inner-text" v-for="x in item">{{x}}<i class=""></i></span>
				</div>
			</transition-group>
			<div class="inculdtitle1">
				<span id="arch2" class="titleword0">{{$t("chaper3[0]")}}</span>
				<div @click="toggleshow1" class="svg0">
					<open-book></open-book>
				</div>
			</div>
			<div class="addphone-wrapper">
				<div class="addphone">{{$t("addphone[0][0]")}}</div>
				<div class="addphone">{{$t("addphone[1][0]")}}</div>
			</div>
			<transition-group name="fade">
				<div :key="'mykey' + index" v-show="isshow1" class="inner" v-for="(item, index) in stepLists1">
					<span class="inner-text" v-for="x in item">{{x}}<i class=""></i></span>
				</div>
			</transition-group>
			<div class="inculdtitle1">
				<span id="arch3" class="titleword0">{{$t("chaper5[0]")}}</span>
				<div @click="toggleshow2" class="svg0">
					<open-book></open-book>
				</div>
			</div>
			<div class="addphone-wrapper">
				<div class="addphone">{{$t("addphone[0][0]")}}</div>
				<div class="addphone">{{$t("addphone[2][0]")}}</div>
			</div>
			<transition-group name="fade">
				<div :key="'mykey' + index" v-show="isshow2" class="inner" v-for="(item, index) in stepLists2">
					<span class="inner-text" v-for="x in item">{{x}}<i class=""></i></span>
				</div>
			</transition-group>
			<div class="inculdtitle1">
				<span id="arch4" class="titleword0">{{$t("chaper10[0]")}}</span>
				<div @click="toggleshow3" class="svg0">
					<open-book></open-book>
				</div>
			</div>
			<div class="addphone-wrapper">
				<div class="addphone">{{$t("addphone[0][0]")}}</div>
				<div class="addphone">{{$t("addphone[3][0]")}}</div>
			</div>
			<transition-group name="fade">
				<div :key="'mykey' + index" v-show="isshow3" class="inner" v-for="(item, index) in stepLists3">
					<span class="inner-text" v-for="x in item">{{x}}<i class=""></i></span>
				</div>
			</transition-group>
			<div class="inculdtitle1">
				<span id="arch5" class="titleword0">{{$t("chaper12[0]")}}</span>
				<div @click="toggleshow4" class="svg0">
					<open-book></open-book>
				</div>
			</div>
			<div class="addphone-wrapper">
				<div class="addphone">{{$t("addphone[0][0]")}}</div>
				<div class="addphone">{{$t("addphone[4][0]")}}</div>
			</div>
			<transition-group name="fade">
				<div :key="'mykey' + index" v-show="isshow4" class="inner" v-for="(item, index) in stepLists4">
					<span class="inner-text" v-for="x in item">{{x}}<i class=""></i></span>
				</div>
			</transition-group>
			<div class="inculdtitle1">
				<span id="arch6" class="titleword0">{{$t("chaper14[0]")}}</span>
				<div @click="toggleshow5" class="svg0">
					<open-book></open-book>
				</div>
			</div>
			<div class="addphone-wrapper">
				<div class="addphone">{{$t("addphone[0][0]")}}</div>
				<div class="addphone">{{$t("addphone[4][0]")}}</div>
			</div>
			<transition-group name="fade">
				<div :key="'mykey' + index" v-show="isshow5" class="inner" v-for="(item, index) in stepLists5">
					<span class="inner-text" v-for="x in item">{{x}}<i class=""></i></span>
				</div>
			</transition-group>
			<div class="inculdtitle1">
				<span id="arch7" class="titleword0">{{$t("chaper16[0]")}}</span>
				<div @click="toggleshow6" class="svg0">
					<open-book></open-book>
				</div>
			</div>
			<transition-group name="fade">
				<div :key="'mykey' + index" v-show="isshow6" class="inner" v-for="(item, index) in stepLists6">
					<span class="inner-text" v-for="x in item">{{x}}<i class=""></i></span>
				</div>
			</transition-group>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
	import titleTop from 'common/title-top/title-top'
	import openBook from 'common/only-svg/open-book'

	export default {
		data() {
			return {
				z: this.$t("chaper2"),
				mainWord: {},
				isshow0: true,
				isshow1: true,
				isshow2: true,
				isshow3: true,
				isshow4: true,
				isshow5: true,
				isshow6: true
			}
		},
		components: {
			titleTop,
			openBook
		},
		created() {
			this.$nextTick(() => {
				this.getlocal()
			})
	},
	methods: {
			toggleshow() {
				this.isshow0 = !this.isshow0
			},
			toggleshow1() {
				this.isshow1 = !this.isshow1
			},
			toggleshow2() {
				this.isshow2 = !this.isshow2
			},
			toggleshow3() {
				this.isshow3 = !this.isshow3
			},
			toggleshow4() {
				this.isshow4 = !this.isshow4
			},
			toggleshow5() {
				this.isshow5 = !this.isshow5
			},
			toggleshow6() {
				this.isshow6 = !this.isshow6
			},
			getlocal() {
				let select = localStorage.getItem('id')
				let anchorElement = document.getElementById(select)
					if(select) {
						anchorElement.scrollIntoView()
					}
				console.log(anchorElement)
				localStorage.removeItem('id')
			}
		},
		computed: {
			stepLists() {
				return this.$t("chaper2")
			},
			stepLists1() {
				return this.$t("chaper4")
			},
			stepLists2() {
				return this.$t("chaper6")
			},
			stepLists3() {
				return this.$t("chaper11")
			},
			stepLists4() {
				return this.$t("chaper13")
			},
			stepLists5() {
				return this.$t("chaper15")
			},
			stepLists6() {
				return this.$t("chaper17")
			},
			addphone() {
				return this.$t("addphone")
			}
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.mainword
		width: 80%
		margin: 0 auto
		padding-bottom: 50px 
		span
			display: block
		.inculdtitle
			display: flex
			justify-content: space-between
			margin-top: 10px
			.titleword0
				color: $color-theme
				font-size: $font-web-medium-s
				margin-bottom: 10px 
				padding-top: 30px
			.svg0
				cursor: pointer
			.titleword1
				width: 90%
				margin: 0 auto 30px 
			.svg1
				display: none
		.addphone-wrapper
			margin-bottom: 10px
			.addphone
				color: $color-text-m
				font-size: $font-size-small-s
				line-height: 18px
			.addphone:nth-child(1)
				font-size: $font-size-medium
				margin-bottom: 5px
		.fade-enter, .fade-leave-to
			transform: translateY(1000px)
		.fade-enter-active
			transition: all 1s ease
		.fade-leave-active
			transition: 0.5s ease
		.inner
			margin-bottom: 3px
			padding: 5px 0
			span
				padding: 5px 0
				width: 90%
				margin: 0 auto
				border-bottom: 1px dashed $color-text-m
				font-size: $font-web-small-s
				&:nth-child(1)
					border-bottom: 1px solid $color-theme
					width: 100%
					font-size: $font-web-small
		.inculdtitle1
			display: flex
			justify-content: space-between
			border-top: 2px solid $color-text-g
			margin-top: 50px
			.titleword0
				color: $color-theme
				font-size: $font-web-medium-s
				margin-bottom: 20px 
				padding-top: 30px
			.svg0
				cursor: pointer
			.titleword1
				width: 90%
				margin: 0 auto 30px 
			.svg1
				display: none
</style>



// WEBPACK FOOTER //
// src/components/prouduct-detail/modified-plastics.vue